export default "__VITE_ASSET__BBl0G$lt__"